<template>
    <div class="upgrade-banner">
      <v-img v-if="$vuetify.breakpoint.mdAndUp && logoPath" :src="logoPath" class="upgrade-banner-logo" contain></v-img>
      <UpgradeLogoBanner v-else-if="$vuetify.breakpoint.mdAndUp" class="upgrade-banner-logo"/>
      <div class="upgrade-banner-text">
        <div class="upgrade-banner-title">{{title}}</div>
        <div class="upgrade-banner-subtitle" v-html="subtitle" ></div>
      </div>
      <PrimaryButton :style="{visibility: isIOS() ? 'hidden' : 'visible'}" class="upgrade-button" :text="$t('common.words.upgrade')" @click="onUpgradeClick" data-qa="upgrade-now-button"/>
    </div>
</template>

<script>
import PrimaryButton from "@/modules/common/components/PrimaryButton/PrimaryButton";
import {postMessageService} from "@/modules/common/services";

export default {
  name: "UpgradeBanner",
  components: {PrimaryButton,
    UpgradeLogoBanner: () => import('@/assets/images/banners/upgrade-banner-logo.svg')
  },
  props: {
    logoPath: {
      type: String
    },
    titleText: {
      type: String
    },
    subtitleText:{
      type: String
    }
  },
  computed: {
    title: function(){
      return this.titleText ? this.titleText : this.$t('common.upgrade_banner.title')
    },
    subtitle: function(){
      return this.subtitleText ? this.subtitleText : this.$t('common.upgrade_banner.subtitle')
    }
  },
  methods: {
    onUpgradeClick: function(){
      this.$emit('upgrade-clicked');
      postMessageService.post("openUpgradePage", '*');
    },
    isIOS: function(){
      return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/abstract/_i18n-mixins';
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.upgrade-banner{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 16px;
  border: 1px solid $core-neutral-400;
  border-radius: 6px;

  @include md-and-up{
    flex-direction: row;
    align-items: center;
    column-gap: 32px;

    height: 128px;
    border-radius: 12px;
  }
}

.upgrade-banner-logo{
  width: 104px;
  height: 104px;
  margin-left: 40px;
  order: 0;
}

.upgrade-banner-text{

  max-width: 100%;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;

  @include md-and-up{
    width: calc(100% - 176px - 228px);
    margin: 0px;
  }

  order: 1;
}

.upgrade-banner-title{
  font-family: var(--primary-font-family);
  font-style: normal;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);

  font-size: 17px;
  line-height: 22px;

  @include md-and-up{
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.01em;
  }
}

.upgrade-banner-subtitle{
  font-family: var(--primary-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;

  margin-top: 8px;
  @include md-and-up{
    font-size: 15px;
    margin-top: 4px;
  }

  color: rgba(0, 0, 0, 0.87);
}

.upgrade-button{
  order: 2;

  margin-left: 24px;
  margin-bottom: 24px;
  ::v-deep .primary-button {
    @include sm-and-down {
      font-size: 13px;
      width: 125px;
    }
    @include md-and-up{
      max-width: none !important;
    }
  }
  @include md-and-up{
    margin-right: 40px;
    margin-left: 0px;
    margin-bottom: 0px;
  }
}
</style>
